import {svgIconWrapper} from '../svg-icon-wrapper';

import CreditCardRegular from './credit-card-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CreditCardRegular {...props} />;
}

SvgComponent.iconName = 'creditCardRegular';

export const CreditCardRegularIcon = svgIconWrapper(SvgComponent);
